import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appMaxLength]',
  standalone:true
})
export class MaxLengthDirective {
  @HostListener('input', ['$event']) onInput(event: InputEvent): void {
    const inputElement = event.target as HTMLInputElement;

    // Restrict the length of the value to 11 characters
    if (inputElement.value.length > 11) {
      inputElement.value = inputElement.value.slice(0, 11);
    }
  }
}
